(function($) {
  $(function() {
    // DIRTY Responsive pricing table JS
    // TODO: make into jQuery plugin for variable colspan & screen width
  
    $( ".compare-chart > ul" ).on( "click", "li", function() {
      var pos = $(this).index()+2;
      $("tr").find('td:not(:eq(0)):not(.group+td)').hide();
      if($('tr td').hasClass('group')) {
        pos = pos+1;
      }
      $('td:nth-child('+pos+')').css('display','table-cell');
      $("tr").find('th:not(:eq(0))').hide();
      $('li').removeClass('active');
      $(this).addClass('active');
    });
  
    // Initialize the media query
    var mediaQuery = window.matchMedia('(min-width: 640px)');
    
    // Add a listen event
    mediaQuery.addListener(makeAdjustments);
    
    // Function to adjust columns at certain media width
    function makeAdjustments(mediaQuery) {
      if (mediaQuery.matches) {
        $('.sep').attr('colspan',5);
        $('.cta').attr('colspan',1);
      } else {
        $('.sep').attr('colspan',2);
        $('.cta').attr('colspan',2);
      }
      window.mediaQueryMatched = mediaQuery.matches;
    }
    
    // On load
    makeAdjustments(mediaQuery);
  });
})(jQuery);